export default "skymp5-front/b34f1d47bf61cc434372ef94f67e4d82.png";